import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'span',
    'documentRecordValue',
    'documentsGrid'
)`
    ${propStyles};
    flex-grow: 1;
    text-align: right;
`;

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentRecordValue.tsx